module.exports = __webpack_public_path__ + "./assets/logo_new.svg";